import "./main-logo.css";

export default function MainLogo(props) {
  return (
    <div className="main-logo">
      <img
        src="/images/LogoSGI.jpg"
        alt="logo"
        onClick={() => {
          if (props.toggleDrawer) {
            props.toggleDrawer(true);
          }
        }}
        style={{
          cursor: "pointer",
          borderRadius: "50%",
          // margin: "5px",
          // padding: "5px",
        }}
      />
    </div>
  );
}
